export default __webpack_public_path__ + "static/54172-cb4c654ac38a1e76f4a6aac2a912efa7.jpg";